import { Injectable } from '@angular/core';
import PipelineConfigurationServiceBase from 'src/shared/services/pipeline-configuration-service-base';

@Injectable({
    providedIn: 'root'
})
export default class PipelineConfigurationService extends PipelineConfigurationServiceBase {

    constructor() {
        super(true);
    }
}
